/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { colors } from '@smartsheet/lodestar-core';
import { SwitchIcon, AddIcon, EditIcon } from '@smartsheet/lodestar-icons';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  activeTabSelector,
  RIGHT_RAIL_TABS,
  setActiveTab,
} from '../../../services/ducks/designerDuck/designerDuck';
import { IconButton } from '../../common/IconButton';
import { RightPanel } from './RightPanel';
import { Bar } from './styled';
import { Container } from './styled/Container';

const baseButtonStyle = css`
  position: 'relative';
  align-items: 'center';
  justify-content: 'center';
  display: 'flex';
  height: 32px;
  :after {
    content: '';
    display: block;
    position: absolute;
    height: 32px;
    transition: left 0.3s cubic-bezier(0.1, 0, 0, 1) 0s;
  }
  :hover {
    background: none;
  }
`;

const buttonHoverStyle = css`
  ${baseButtonStyle};
  :after {
    left: 48px;
    width: 6px;
    background-color: rgba(179, 204, 234, 0);
    border-radius: 2px 0 0 2px;
    pointer-events: none;
  }
  :hover:after {
    left: 41px;
    background-color: rgba(179, 204, 234, 1);
  }
`;

const buttonActiveStyle = css`
  ${baseButtonStyle}
  :after {
    left: 7px;
    width: 32px;
    height: 32px;
    background-color: rgb(179, 204, 234);
    border-radius: 2px;
    pointer-events: none;
    z-index: -1;
  }
`;

export const RightRail = () => {
  const dispatch = useDispatch();
  const { t: translate } = useTranslation();
  const activeButton = useSelector(activeTabSelector);

  return (
    <Container>
      <RightPanel
        isOpen={activeButton !== undefined}
        activePanelId={activeButton}
      />
      <Bar
        css={css`
          height: ${activeButton === RIGHT_RAIL_TABS.EDIT_MODULE
            ? '144px'
            : '96px'};
        `}
      >
        <IconButton
          aria-label={translate('common:runLog')}
          appearance="borderless"
          onClick={() => {
            dispatch(setActiveTab(0));
          }}
          css={
            activeButton === RIGHT_RAIL_TABS.RUNLOG
              ? buttonActiveStyle
              : buttonHoverStyle
          }
        >
          <SwitchIcon color={colors.neutralDark40} />
        </IconButton>
        <IconButton
          aria-label={translate('designer:rightRail.addModule')}
          appearance="borderless"
          onClick={() => {
            dispatch(setActiveTab(1));
          }}
          css={
            activeButton === RIGHT_RAIL_TABS.ADD_MODULE
              ? buttonActiveStyle
              : buttonHoverStyle
          }
        >
          <AddIcon color={colors.neutralDark40} />
        </IconButton>
        {activeButton === RIGHT_RAIL_TABS.EDIT_MODULE ? (
          <IconButton
            aria-label={translate('designer:rightRail.editModule')}
            appearance="borderless"
            onClick={() => {
              dispatch(setActiveTab(2));
            }}
            css={
              activeButton === RIGHT_RAIL_TABS.EDIT_MODULE
                ? buttonActiveStyle
                : buttonHoverStyle
            }
          >
            <EditIcon color={colors.neutralDark40} />
          </IconButton>
        ) : null}
      </Bar>
    </Container>
  );
};
